// extracted by mini-css-extract-plugin
module.exports = {"printingOptions":"style_printingOptions__2018z"};